/**
 * Region schedule's scope control, worn beside the page title the way
 * Overview wears its region picker: the shared scope picker when the teacher
 * has more than one region, otherwise just the region's name.
 */
import { useViewport } from '../../../../hooks/useViewport';
import { ScopePicker } from '../../primitives/scope/ScopePicker';
import { useRegionScheduleScope } from '../use-region-schedule-scope';

export default function RegionSchedulePicker() {
  const { isPhone } = useViewport();
  const { regions, current, hrefFor } = useRegionScheduleScope();
  if (regions.length < 2) return <span style={{ color: 'var(--nb-subtle)' }}>{current?.name}</span>;
  return (
    <ScopePicker
      label={current?.name ?? 'Region'}
      currentRegionId={current?.id ?? null}
      regions={regions}
      hrefFor={hrefFor}
      isPhone={isPhone}
      showAllRegions={false}
    />
  );
}
